module.exports = __webpack_public_path__ + "static/media/Bonnie-Jumpscare.157447f6.webp";